import React from 'react';

import {Field} from 'redux-form';

import Table from 'components/Table';
import Money from 'components/Money';
import {NumberField, TextField, SearchField} from 'components/Fields';

import './styles.css';

const ItemFields = ({
  lineAmount,
  xeroTaxRatesOptions,
  onQuantityChange,
  onUnitPriceChange
}) => (
  <div className="ItemFields">
    <Table>
      <Table.Header>
        <Table.HeaderItem heading="Description" className="itemDescription" />
        <Table.HeaderItem heading="QTY" className="quantity" />
        <Table.HeaderItem heading="Unit price (£)" className="unitPrice" />
        <Table.HeaderItem heading="Tax rate" className="xeroTaxRate" />
        <Table.HeaderItem heading="Amount" className="amount" />
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Field
              className="itemDescription"
              name="itemDescription"
              type="input"
              component={TextField}
            />
          </Table.Cell>
          <Table.Cell>
            <Field
              className="quantity"
              name="quantity"
              component={NumberField}
              min="1"
              onChange={onQuantityChange}
            />
          </Table.Cell>
          <Table.Cell>
            <Field
              className="unitPrice"
              name="unitPrice"
              component={NumberField}
              step="0.01"
              onChange={onUnitPriceChange}
            />
          </Table.Cell>
          <Table.Cell>
            <Field
              className="xeroTaxRate"
              name="xeroTaxRate"
              type="select"
              component={SearchField}
              placeholder="Select account ..."
              options={xeroTaxRatesOptions}
              disabled={xeroTaxRatesOptions.length <= 1}
            />
          </Table.Cell>
          <Table.Cell>
            <div className="lineAmount">
              <Money amount={lineAmount} />
            </div>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  </div>
);

export default ItemFields;
